import axios from 'axios';
import { API_URL } from '../env';

const client = axios.create({
  baseURL: API_URL,
});

const superclient = axios.create({
  baseURL: API_URL,
});

export const GET = async (endpoint) => {
  const Token = localStorage.getItem("token");
  try {
    const headerData = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`
      }
    };

    const response = await client.get(endpoint, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in GET request to ${endpoint}:`, error);
    throw error;
  }
};

export const POST = async (endpoint, data, isFormData = false) => {
  const Token = localStorage.getItem("token");
  try {
    var headerData = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        Authorization: `Bearer ${Token}`
      }
    }

    const response = await client.post(endpoint, data, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in POST request to ${endpoint}:`, error);
    throw error;
  }
};

export const PUT = async (endpoint, data, isFormData = false) => {
  const Token = localStorage.getItem("token");
  try {
    var headerData = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        Authorization: `Bearer ${Token}`
      }
    }

    const response = await client.put(endpoint, data, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in PUT request to ${endpoint}:`, error);
    throw error;
  }
};

export const DELETE = async (endpoint) => {
  const Token = localStorage.getItem("token");
  try {
    const headerData = {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    };

    const response = await client.delete(endpoint, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in DELETE request to ${endpoint}:`, error);
    throw error;
  }
};

export const SUPERGET = async (endpoint) => {
  const Token = localStorage.getItem("token");
  try {
    const headerData = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`
      }
    };

    const response = await superclient.get(endpoint, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in GET request to ${endpoint}:`, error);
    throw error;
  }
};

export const SUPERPOST = async (endpoint, data, isFormData = false) => {
  const Token = localStorage.getItem("token");
  try {
    var headerData = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        Authorization: `Bearer ${Token}`
      }
    }

    const response = await superclient.post(endpoint, data, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in POST request to ${endpoint}:`, error);
    throw error;
  }
};

export const SUPERPUT = async (endpoint, data, isFormData = false) => {
  const Token = localStorage.getItem("token");
  try {
    var headerData = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        Authorization: `Bearer ${Token}`
      }
    }

    const response = await superclient.put(endpoint, data, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in PUT request to ${endpoint}:`, error);
    throw error;
  }
};

export const SUPERDELETE = async (endpoint) => {
  const Token = localStorage.getItem("token");
  try {
    const headerData = {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    };

    const response = await superclient.delete(endpoint, headerData);
    return response.data;
  } catch (error) {
    console.error(`Error in DELETE request to ${endpoint}:`, error);
    throw error;
  }
};